import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import(
        './cash-register-payment/pages/payment-initialization/payment-initialization.component'
      ).then(m => m.PaymentInitializationComponent)
  },
  {
    path: ':hostName',
    loadComponent: () =>
      import(
        './cash-register-payment/pages/payment-initialization/payment-initialization.component'
      ).then(m => m.PaymentInitializationComponent)
  },
  {
    path: ':hostName/:slugName',
    loadComponent: () =>
      import(
        './cash-register-payment/pages/payment-initialization/payment-initialization.component'
      ).then(m => m.PaymentInitializationComponent)
  },
  // {
  //   path: 'payment',
  //   loadComponent: () =>
  //     import('./cash-register-payment/pages/payment/payment.component').then(
  //       m => m.PaymentComponent
  //     )
  // },
  // {
  //   path: 'payments/:paymentId',
  //   loadComponent: () =>
  //     import('./cash-register-payment/pages/payment/payment.component').then(
  //       m => m.PaymentComponent
  //     )
  // },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
